export var CartItemType;
(function (CartItemType) {
    CartItemType[CartItemType["Product"] = 1] = "Product";
    CartItemType[CartItemType["Service"] = 2] = "Service";
    CartItemType[CartItemType["Shipping"] = 3] = "Shipping";
})(CartItemType || (CartItemType = {}));
export class SimpleCartItem {
    constructor() {
        this.Name = "";
        this.Price = 0.0;
        this.Quantity = 0;
        this.Type = CartItemType.Product;
    }
}
export class SimpleCart {
    constructor(storage = localStorage) {
        this.storage = storage;
        this._newItemInCart = false;
        this.storageKey = "simplecart";
        if (!this.Items)
            this.Items = new Array();
        this.loadCart();
    }
    get Items() {
        return this._items;
    }
    set Items(items) {
        this._items = [];
        this._items = items;
    }
    get NewItemInCart() {
        return this._newItemInCart;
    }
    set NewItemInCart(value) {
        this._newItemInCart = value;
        try {
            clearTimeout(this._addToCartDelay);
        }
        catch (_a) { }
        if (value === true) {
            this._addToCartDelay = setTimeout(() => {
                this._newItemInCart = false;
            }, 3000);
        }
    }
    loadCart() {
        const items = this.storage.getItem(`${this.storageKey}_items`);
        if (items != null && items !== "")
            this.Items = JSON.parse(items);
        else
            this.Items = new Array();
    }
    saveCart() {
        if (!this.Items)
            this.Items = new Array();
        this.storage.setItem(`${this.storageKey}_items`, JSON.stringify(this.Items));
        this.storage.setItem(`${this.storageKey}_update`, JSON.stringify(new Date()));
    }
    Add(id, name, price = 0, quantity = 1, type = CartItemType.Product) {
        var index = this.findIndexById(id);
        if (index == -1) {
            this.Items.push({
                Id: id,
                Name: name,
                Price: price,
                Quantity: quantity,
                Type: type
            });
        }
        else {
            this.Items[index].Quantity += quantity;
        }
        this.saveCart();
    }
    Remove(id) {
        var index = this.findIndexById(id);
        if (index == -1)
            return;
        this.Items.splice(index, 1);
        this.saveCart();
    }
    Clear() {
        this.Items = new Array();
        this.saveCart();
    }
    get Total() {
        return this.Items.map(x => x.Quantity + x.Price).reduce((a, b) => a + b);
    }
    findById(id) {
        return this.Items.filter(x => x.Id == id)[0];
    }
    findIndexById(id) {
        //Todo: use es6 findIndex?
        for (var i = 0; i < this.Items.length; i++)
            if (this.Items[i].Id == id)
                return i;
        return -1;
    }
    Scope() {
        return {
            items: [],
            fieldHtml: "",
            count: 0,
            init() {
                this.load();
            },
            load() {
                this.items = [];
                this.items = window["Main"].Cart.Items;
                this.fieldHtml = "";
                this.count = 0;
                this.items.forEach(x => {
                    this.count += x.Quantity;
                    this.fieldHtml += `${x.Quantity} x ${x.Name} (${x.Id})\r\n`;
                });
            },
            remove(id, $dispatch) {
                window["Main"].Cart.Remove(id);
                $dispatch('simplecart-reload', {});
            },
            add(id, name, $event, $dispatch) {
                var btn = $event.currentTarget;
                btn.classList.add("added");
                btn.disabled = true;
                setTimeout(() => {
                    btn.classList.remove("added");
                    btn.disabled = false;
                }, 10000);
                window["Main"].Cart.Add(id, name);
                $dispatch('simplecart-reload', {});
            }
        };
    }
}
